export default {
  no_restrictions: 'No restrictions',
  can_only_redeem: {
    online: 'Customers can only redeem this online',
    instore: 'Customers can only redeem this in-store',
  },
  exchange_dates: {
    can_exchange: 'Customers can exchange %{currencyName} for this reward',
    from: 'from %{from}',
    to: 'until %{to}',
  },
  day: 'day',
  day_plural: 'days',
  hour: 'hour',
  hour_plural: 'hours',
  after_activation:
    'After customers activate this reward, they can see it for %{count} %{unit}.',
  max_amount: 'Customers cannot redeem more than $%{amount}',
  points_cap: {
    title: 'Points restrictions',
    subtitle:
      'Set limits on how many points customers can earn per transaction',
    max_points_per_transaction: 'Maximum points per transaction',
    max_points_help: 'Leave blank for unlimited points earning',
    save: 'Save restrictions',
    cancel: 'Cancel',
    no_cap: 'No limit',
    points_capped: 'Capped at %{cap} points per transaction',
    modal: {
      do_not_limit: "Don't limit %{currency}",
      do_limit: 'Limit %{currency}',
      limit_subtitle:
        'Restrict the max number of %{currency} customers can collect per purchase',
      maximum: {
        title: 'Maximum %{currency} per purchase',
        Placeholder: 'maximum placeholder',
      },
    },
  },
  restrictions_modal: {
    title: 'Restrictions',
    description:
      'Add specific restrictions around how customers can collect points.',
    cancel: 'Cancel',
    save: 'Save',
  },
}
